(function () {
  function moneyText(el) {
    return el ? el.getAttribute('data-price') : '';
  }

  function syncVariant(variantId, priceText) {
    document.querySelectorAll('.mcos-variant-id').forEach(function (input) {
      input.value = variantId;
    });
    if (priceText) {
      document.querySelectorAll('[data-mcos-price]').forEach(function (node) {
        node.textContent = priceText;
      });
      document.querySelectorAll('[data-mcos-atc-price]').forEach(function (node) {
        node.textContent = priceText;
      });
    }
  }

  function syncQty(value) {
    document.querySelectorAll('.mcos-qty-input').forEach(function (input) {
      input.value = value;
    });
  }

  document.addEventListener('change', function (event) {
    var color = event.target.closest('.mcos-color-radio');
    if (color) {
      syncVariant(color.getAttribute('data-variant-id'), moneyText(color));
    }

    if (event.target.classList.contains('mcos-qty-input')) {
      var qty = parseInt(event.target.value, 10);
      if (!qty || qty < 1) qty = 1;
      event.target.value = qty;
      syncQty(qty);
    }
  });

  document.addEventListener('click', function (event) {
    var qtyButton = event.target.closest('[data-mcos-qty]');
    if (qtyButton) {
      var qtyWrap = qtyButton.closest('.mcos-qty');
      var qtyInput = qtyWrap ? qtyWrap.querySelector('.mcos-qty-input') : null;
      if (!qtyInput) return;
      var qty = parseInt(qtyInput.value, 10) || 1;
      qty += qtyButton.getAttribute('data-mcos-qty') === 'plus' ? 1 : -1;
      if (qty < 1) qty = 1;
      qtyInput.value = qty;
      syncQty(qty);
      return;
    }

    var faqButton = event.target.closest('.mcos-faq__button');
    if (faqButton) {
      var item = faqButton.closest('.mcos-faq');
      if (item) {
        item.classList.toggle('is-open');
        faqButton.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
      }
    }
  });
})();
